// Normalize a ZIP code so comparisons work even when Excel dropped a leading zero
// or the value is in ZIP + 4 form.
//
// Two problems this handles:
//   1. Excel often strips the first zero, so "03301" arrives as "3301".
//   2. A geocoder may return ZIP + 4 like "03301-5605".
//
// We fix the leading zero first, then keep only the first 5 numbers, so both
// sides of a comparison end up as the same 5 number base ZIP.
//
// Examples:
//   "3301"        -> "03301"
//   "3301-9997"   -> "03301"
//   "33019997"    -> "03301"
//   "03301-5605"  -> "03301"
//   "90210"       -> "90210"
export const normalizeZipCode = (zip) => {
	if (!zip) return "";

	// Work with a trimmed string in case the value is a number or has stray spaces.
	let zipString = zip.toString().trim();

	// Count only the number characters, ignoring any dash.
	const numberCount = zipString.replace(/\D/g, "").length;

	// 4 or 8 numbers means a single leading zero was stripped, so add it back.
	if (numberCount === 4 || numberCount === 8) {
		zipString = "0" + zipString;
	}

	// Keep only the number characters, then take the first 5 (the base ZIP).
	const numbersOnly = zipString.replace(/\D/g, "");
	return numbersOnly.slice(0, 5);
};
